import {
  SOLUTION_RESOURCE_PRODUCT_NAMES,
  type SolutionResourceProduct,
  getSolutionResourcesForProduct,
} from '@/data/shared/solutionResources';

import { AniSlideUp } from '@/components/shared/animations/basic';

import ResourceDownloadCard from './ResourceDownloadCard';

const HEADING_CLASS =
  'text-[22px] font-bold leading-[140%] tracking-[-0.44px] text-apps-coreGray01 lg:text-[clamp(22px,2vw,28px)] lg:tracking-[-0.56px]';

type Props = {
  product: SolutionResourceProduct;
};

/**
 * ### ResourceProductGroup
 *
 * Every resource of one product, under a heading naming that product. The
 * heading is an h3: the page title is the visually hidden h1 and the section
 * title above these groups is the h2.
 *
 * @param props.product Product whose resources are listed
 */
export default function ResourceProductGroup({ product }: Props) {
  const resources = getSolutionResourcesForProduct(product);
  const headingId = `resource-group-${product}`;

  return (
    <section aria-labelledby={headingId}>
      <AniSlideUp>
        <h3 className={HEADING_CLASS} id={headingId}>
          {SOLUTION_RESOURCE_PRODUCT_NAMES[product]}
        </h3>
        <ul className="mt-[20px] grid gap-[14px] lg:mt-[clamp(20px,2.5vw,32px)] lg:grid-cols-2 lg:gap-[16px]">
          {resources.map((resource) => (
            <li className="flex" key={resource.id}>
              <ResourceDownloadCard resource={resource} />
            </li>
          ))}
        </ul>
      </AniSlideUp>
    </section>
  );
}
